import React, { Component } from "react";

import { Container } from "react-bootstrap";
import "./_newomr.scss";
import { withRouter } from "react-router-dom";

import NewOmrHistory from "./NewOmrHistory";
import NewOmrUpload from "./NewOmrUpload";
import NewOmrDload from "./NewOmrDload";

class NewMainOmr extends Component {
  constructor(props) {
    super(props);
    const componentFromPath = this.getComponentFromPath(
      props.location.pathname,
    );
    this.state = {
      selectedButton: componentFromPath,
      component: componentFromPath,
    };
  }

  componentDidUpdate(prevProps) {
    if (this.props.location.pathname !== prevProps.location.pathname) {
      const componentFromPath = this.getComponentFromPath(
        this.props.location.pathname,
      );
      this.setState({
        selectedButton: componentFromPath,
        component: componentFromPath,
      });
    }
  }

  getComponentFromPath(pathname) {
    const lastSegment = pathname.split("/").filter(Boolean).pop();
    if (["history", "upload", "download"].includes(lastSegment)) {
      return lastSegment;
    }
    return "history"; // default
  }

  handleClick = (btn) => {
    const basePath =
      this.props.match.url.split("/").slice(0, -1).join("/") || "";
    this.props.history.push(`${basePath}/${btn}`);
  };

  render() {
    const { selectedButton } = this.state;

    let RenderComponent;
    switch (this.state.component) {
      case "upload":
        RenderComponent = <NewOmrUpload />;
        break;
      case "download":
        RenderComponent = <NewOmrDload />;
        break;
      default:
        RenderComponent = <NewOmrHistory />;
        break;
    }

    const TABS = [
      { key: "history", label: "Upload History", icon: "🗂", sub: "View & evaluate uploaded OMR sheets" },
      { key: "upload", label: "Upload OMR", icon: "⬆️", sub: "Upload scanned answer sheets" },
      { key: "download", label: "Sample OMR", icon: "⬇️", sub: "Download a blank OMR sheet" },
    ];
    const active = TABS.find((t) => t.key === selectedButton) || TABS[0];

    return (
      <div style={ST.page}>
        <Container fluid style={{ maxWidth: "100%", padding: "0 20px" }}>
          {/* Header */}
          <div style={ST.header}>
            <div style={ST.headIcon}>🧾</div>
            <div>
              <div style={ST.title}>OMR Evaluation</div>
              <div style={ST.subtitle}>{active.sub}</div>
            </div>
          </div>

          {/* Segmented tab bar */}
          <div style={ST.tabBar}>
            {TABS.map((t) => {
              const on = selectedButton === t.key;
              return (
                <button
                  key={t.key}
                  type="button"
                  onClick={() => this.handleClick(t.key)}
                  style={{ ...ST.tab, ...(on ? ST.tabActive : {}) }}
                >
                  <span style={{ fontSize: 16 }}>{t.icon}</span>
                  <span>{t.label}</span>
                </button>
              );
            })}
          </div>

          {/* Content card */}
          <div style={ST.card}>{RenderComponent}</div>
        </Container>
      </div>
    );
  }
}

// Self-contained styles for the OMR main shell (purple theme, matches OMR pages).
const ST = {
  page: {
    background: "linear-gradient(135deg, #f0f4ff 0%, #faf5ff 100%)",
    minHeight: "100vh",
    padding: "22px 12px 60px",
  },
  header: { display: "flex", alignItems: "center", gap: 14, marginBottom: 18 },
  headIcon: {
    width: 46, height: 46, borderRadius: 12, background: "#f5f3ff",
    border: "1px solid #ddd6fe", display: "flex", alignItems: "center",
    justifyContent: "center", fontSize: 22, flexShrink: 0,
  },
  title: { fontSize: 20, fontWeight: 800, color: "#4c1d95", lineHeight: 1.1 },
  subtitle: { fontSize: 13, color: "#7c6f9b", marginTop: 3 },
  tabBar: {
    display: "inline-flex", gap: 4, background: "#efeafc",
    border: "1px solid #e3dbf7", borderRadius: 12, padding: 4, marginBottom: 16,
    flexWrap: "wrap",
  },
  tab: {
    display: "inline-flex", alignItems: "center", gap: 8, cursor: "pointer",
    border: "none", background: "transparent", color: "#6d5f93",
    fontSize: 13.5, fontWeight: 700, padding: "9px 18px", borderRadius: 9,
    transition: "all .15s",
  },
  tabActive: {
    background: "#7c3aed", color: "#fff",
    boxShadow: "0 4px 12px rgba(124,58,237,.30)",
  },
  card: {
    background: "#fff", border: "1px solid #ece7f9", borderRadius: 16,
    boxShadow: "0 4px 24px rgba(76,29,149,0.06)", padding: "8px 6px",
    overflow: "visible",
  },
};
export default withRouter(NewMainOmr);
